import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import * as actions from '../actions/search.action';
import { switchMap, map, catchError, withLatestFrom } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { getActiveLanguageNoCulture } from '@teamfoster/sdk/language-ngrx';
import { SearchService } from '../../services';
import { getSearchPageInfo, getSearchQuery } from '../selectors';
import { query } from 'express';

@Injectable()
export class SearchEffects {
  constructor(private actions$: Actions, private service: SearchService, private store: Store) {}

  getGlobalSearchResults$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(actions.GlobalSearch),
      withLatestFrom(this.store.select(getActiveLanguageNoCulture)),
      switchMap(([{ searchQuery }, lang]) =>
        this.service.getGlobalSearchResults(searchQuery, lang).pipe(
          map(products => actions.GlobalSearchSuccess({ products })),
          catchError(error => of(actions.GlobalSearchFail({ error })))
        )
      )
    );
  });

  LoadSearchResults$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(actions.LoadSearchResults),
      withLatestFrom(this.store.select(getActiveLanguageNoCulture)),
      switchMap(([{ searchQuery }, lang]) =>
        this.service.getSearchResults(searchQuery, undefined, lang).pipe(
          map(products => actions.LoadSearchResultsSuccess({ products })),
          catchError(error => of(actions.LoadSearchResultsFail({ error })))
        )
      )
    );
  });

  LoadMoreSearchResults$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(actions.LoadMoreSearchResults),
      withLatestFrom(
        this.store.select(getSearchQuery),
        this.store.select(getSearchPageInfo),
        this.store.select(getActiveLanguageNoCulture)
      ),
      switchMap(([{}, q, pageInfo, lang]) =>
        this.service.getSearchResults(q!, pageInfo?.cursor, lang).pipe(
          map(products => actions.LoadSearchResultsSuccess({ products, loadMore: true })),
          catchError(error => of(actions.LoadSearchResultsFail({ error })))
        )
      )
    );
  });
}
